import { styled, Typography } from '@mui/material';

export const CardDate = styled(Typography, {
  shouldForwardProp: (props) => props !== 'isCompact',
})(({ isCompact = false }: { isCompact?: boolean }) => ({
  marginTop: `${isCompact ? 6 : 2}px`,
  fontSize: '12px',
  lineHeight: '12px',
  fontWeight: '400',
  color: '#52606b',
}));

export const CardDescription = styled(Typography, {
  shouldForwardProp: (props) => props !== 'isCompact',
})<{ isCompact?: boolean }>(({ theme, isCompact }) => ({
  overflow: 'hidden',
  display: '-webkit-box',
  boxOrient: 'vertical',
  WebkitBoxOrient: 'vertical',
  fontSize: '12px',
  lineHeight: '18px',
  color: theme.palette.text.primary,
  paddingTop: `${isCompact ? 6 : 8}px`,
  WebkitLineClamp: 3,
  lineClamp: 3,
}));
